























import {Component, Emit, Model, Prop, Vue, Watch} from "vue-property-decorator";
import {RegionStore} from "@/modules/regions/store";
import ProvinceLabel from "@/modules/regions/ProvinceLabel/index.vue";
import {Province} from "@/interfaces/entity";
import {toSlug} from "@/shared/services/helper/utils";

@Component({
    name: "ProvinceSelector",
    components: {ProvinceLabel}
})
export default class extends Vue {
    @Prop({type: Boolean, default: false}) readonly disabled!: boolean;
    @Prop({type: String, default: "Chọn tỉnh/tp"}) readonly placeholder!: string;
    @Prop({default: 'default'}) readonly size!: 'default' | 'small' | 'large';


    @Prop({default: 1})
    readonly countryId!: number;

    @Model("change", {type: Number})
    readonly provinceId!: number;

    @Emit('change')
    handleChange(value?: number) {
        const province = this.provinces.find((province: Province) => province.id === value);
        this.$emit("province-name", province?.name || "");
        return value;
    }

    provinces: Province[] = [];

    @Watch("countryId", {immediate: true})
    async onChangeCountryId(val: number, oldVal: number) {
        if (!val) {
            this.provinces = [];
            this.handleChange();
        }
        try {
            this.provinces = await RegionStore.getProvinces(val);
            if (!this.provinceId) return;
            if (this.provinces.some((province: Province) => province.id === this.provinceId)) return;
            this.handleChange();
        } catch (e) {
            this.$notification.error({
                message: "Thất bại",
                description: e?.response?.data?.message || "Đã có lỗi xảy ra"
            });
        }
    }

    private filterOption(input: string, option: any) {
        return (toSlug(option.componentOptions.children[0].elm.textContent, " ")
                .toLowerCase()
                .indexOf(toSlug(input, " ")
                .toLowerCase()) >= 0);
    }
}
